import React from "react";
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  useAsyncDebounce,
} from "react-table";
import { Error } from "../_common/Error";
import { Spinner } from "../_common/Spinner";

function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <span>
      <input
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        type="search"
        className="form-control input-sm input-small input-inline"
      />
    </span>
  );
}

function StatusDatatable({
  statuses,
  isLoading,
  error,
  setOpensidePanel,
  setStatusDetails,
  confirmDelete,
}) {
  const columns = [
    {
      Header: "Status Name",
      accessor: "statusName",
      sortType: "basic",
      Cell: ({ row }) => (
        <div style={{ float: "left", width: "80%" }}>
          <label
            className="border-radius-5"
            style={{
              padding: "6px 12px",
              backgroundColor: row.original.color,
              color: "#fff",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            {row.original.statusName}
          </label>
        </div>
      ),
    },

    {
      Header: "",
      accessor: "id",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div style={{ textAlign: "right" }}>
          <button
            type="button"
            className="btn edit"
            onClick={(e) => {
              e.preventDefault();
              setOpensidePanel(true);
              setStatusDetails(row.original);
            }}
            style={{
              marginRight: "8px",
              color: "#1bbc9b",
            }}
          >
            <i className="fa fa-pencil"></i>
          </button>
          <button
            className="btn delete"
            href="#!"
            onClick={(e) => {
              e.preventDefault();
              confirmDelete(row.original);
            }}
            style={{ color: "#e7505a" }}
          >
            <i className="fa fa-trash-o"></i>
          </button>
        </div>
      ),
      editRow({ id }) {
        console.log(id);
        return false;
      },
    },
  ];
  if (isLoading) {
    return <Spinner />;
  }

  if (error) {
    return <Error message={error} />;
  }

  const hasStatuses = statuses && statuses.length;
  if (!hasStatuses) {
    return (
      <div>
        <h6 style={{ textAlign: "center", fontWeight: "bold" }}>
          All your Status will show here. Use the 'Add New +' button to add a
          Status.
        </h6>
      </div>
    );
  }

  return <StatusTable statusesData={statuses} columns={columns} />;
}

function StatusTable({ statusesData, columns, updateMyData }) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = React.useMemo(() => statusesData, []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
  } = useTable({ columns, data, updateMyData }, useGlobalFilter, useSortBy);

  return (
    <div className="dataTables_wrapper no-footer">
      <div className="dataTables_filter">
        <label>
          Search:
          {
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={state.globalFilter}
              setGlobalFilter={setGlobalFilter}
            />
          }
        </label>
      </div>
      <table
        id="status-Data-Table"
        className="table table-striped table-hover table-bordered dataTable no-footer"
        {...getTableProps()}
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  className={
                    !column.disableSortBy
                      ? column.isSorted
                        ? column.isSortedDesc
                          ? "sorting_desc"
                          : " sorting_asc"
                        : "sorting"
                      : ""
                  }
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export { StatusDatatable };
